import { put, call, takeLatest, delay } from "redux-saga/effects";

import { AJAX } from "../../shared/make_ajax_action";
import requestData from "../../shared/request_data";
import * as loadingActions from "./actions/loading";
import * as dhsa from "./actions/data_hub_search";

// functions below use requestData and then put options to modify the store based on the response
const actionTypesBasedOnTriggeringType = (action) => {
  let start, response_received, finished;

  if (action.triggeringType === dhsa.SAVED_SEARCH_OPTIONS_TRIGGER) {
    start = dhsa.SAVED_SEARCH_OPTIONS_START;
    response_received = dhsa.SAVED_SEARCH_OPTIONS_RESPONSE_RECEIVED;
    finished = dhsa.SAVED_SEARCH_OPTIONS_FINISHED;
  } else if (action.triggeringType === dhsa.DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER) {
    start = dhsa.SAVED_SEARCH_OPTIONS_START;
    response_received = dhsa.SAVED_SEARCH_OPTIONS_RESPONSE_RECEIVED;
    finished = dhsa.SAVED_SEARCH_OPTIONS_FINISHED;
  } else if (action.triggeringType === dhsa.SAVED_SEARCH_SUBMIT_TRIGGER) {
    start = dhsa.SAVED_SEARCH_SUBMIT_START;
    response_received = dhsa.SAVED_SEARCH_SUBMIT_RESPONSE_RECEIVED;
    finished = dhsa.SAVED_SEARCH_SUBMIT_FINISHED;
  } else {
    start = loadingActions.LOADING_DATA_STARTED;
    response_received = loadingActions.DATA_LOADED;
    finished = loadingActions.LOADING_DATA_FINISHED;
  }
  return {
    start: start,
    response_received: response_received,
    finished: finished
  };
};

function* dataRequest(action) {
  const actionTypes = actionTypesBasedOnTriggeringType(action);

  yield put({
    triggeringType: action.triggeringType, type: actionTypes.start
  });

  yield delay(500);

  const json = yield call(requestData, action);

  yield put({ triggeringType: action.triggeringType, type: actionTypes.response_received, payload: json });

  yield put({ triggeringType: action.triggeringType, type: actionTypes.finished});
}

// delegates to a fetch* functon based on the action triggeringType
function* handleAjax(action) {
  yield dataRequest(action);
}

export default function* rootSaga() {
  yield takeLatest(AJAX, handleAjax);
}
